import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type {
  ListJobsRequest,
  ListJobsResponse,
  JobDetailsResponse,
} from '@/common-types';

/**
 * Fetch a page of jobs from the Log Oracle List Jobs API.
 * POST /api/log-oracle/jobs/list
 */
export async function listJobs(
  params: ListJobsRequest
): Promise<ListJobsResponse> {
  const response = await fetchApi<ListJobsResponse>(API_ENDPOINTS.LIST_JOBS, {
    method: 'POST',
    body: params,
  });
  return response.data;
}

/**
 * Fetch detailed job logs and presigned URLs by transaction ID and region.
 * GET /api/log-oracle/jobs?region=&transactionId=
 * Requires jobs_in_log_oracle permission.
 */
export async function getJobDetails(
  transactionId: string,
  region: string
): Promise<JobDetailsResponse> {
  const endpoint = API_ENDPOINTS.JOB_DETAILS({ region, transactionId });
  const response = await fetchApi<JobDetailsResponse>(endpoint);
  return response.data;
}

export default { listJobs, getJobDetails };
